module.exports = __webpack_public_path__ + "img/高老庄男.e92f7525.png";